import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Axis } from 'src/app/models/survey/axis';
import { LinkQuestions } from 'src/app/models/survey/linkquestions';
import { Option } from 'src/app/models/survey/options';
import { Question } from 'src/app/models/survey/question';
import { QuestionForm } from 'src/app/models/survey/question-form';
import { Survey } from 'src/app/models/survey/survey';
import { SvSection } from 'src/app/models/survey/svsection';
import { AxisService } from 'src/app/services/survey/axis.service';
import { LinkquestionsService } from 'src/app/services/survey/linkquestions.service';
import { OptionsService } from 'src/app/services/survey/options.service';
import { QuestionTypeService } from 'src/app/services/survey/question-type.service';
import { QuestionService } from 'src/app/services/survey/question.service';
import { SurveyService } from 'src/app/services/survey/survey.service';
import { SvsectionService } from 'src/app/services/survey/svsection.service';

@Component({
  selector: 'app-testpreview',
  templateUrl: './testpreview.component.html',
  styleUrls: ['./testpreview.component.scss']
})
export class TestpreviewComponent implements OnInit {

  form: FormGroup;
  survey: Survey = null;
  svsections: SvSection[] = null;
  questions: Question[];
  linkQuestions: LinkQuestions[];
  opts: Option[];

  questionForm: QuestionForm = {};
  questionsForm: QuestionForm[] = [];



  constructor(
    private svService: SurveyService,
    private qtService: QuestionTypeService,
    private svsecService: SvsectionService,
    private qService: QuestionService,
    private optService: OptionsService,
    private axService: AxisService,
    private linkService: LinkquestionsService,
    private fb: FormBuilder,
    private actRoute: ActivatedRoute) { }

  ngOnInit() {
    const params = this.actRoute.snapshot.params;
    if (params['id']) {
      /* Consulta por ID de encuesta */
      this.getOneSurvey(params['id']);
    } else if (params['url']) {
      /* Consulta por URL de encuesta */
      this.getOneUrlSurvey(params['url']);
    }

  }

  getOneUrlSurvey(url: string) {
    if (url) {
      this.svService.getOneUrl(url)
        .subscribe(
          res => {
            this.survey = res['data'];
            this.getSvSec4Survey(this.survey);
            console.log("Survey: ", this.survey);
          },
          err => console.error(err)
        );
    } else {
    }
  }

  getOneSurvey(id: string) {
    if (id) {
      this.svService.getOne(id)
        .subscribe(
          res => {
            this.survey = res['data'];
            this.getSvSec4Survey(this.survey);
          },
          err => console.error(err)
        );
    }
  }

  getSvSec4Survey(survey: Survey) {
    if (survey) {
      this.svsecService.get4Survey(survey.id.toString())
        .subscribe(
          res => {
            this.svsections = res['data'];
            if (this.svsections.length > 0) {
              this.survey.sections = this.svsections;
              this.getQuestion4Section(this.survey.sections);
            }
          },
          err => console.error(err)
        );
    }
  }

  getQuestion4Section(sections: SvSection[]) {
    sections.forEach((s, i) => {
      this.qService.get4Section(s.id.toString())
        .subscribe(
          res => {
            this.questions = res['data'];
            if (this.questions.length > 0) {
              s.questions = this.questions;
              s.questions.forEach(q => {
                this.getLinks4Question(q);
                this.questionsForm.push(q);
              });
              this.questionsForm.forEach((q, i) => {
                if (i == 0) {
                  q.sectiontitle = s.title;
                  q.sectionsummary = s.summary;
                  q.sectiondetail = s.detail;
                }
                q.idsurvey = this.survey.id;
                q.idsection = s.id;
                q.sectionorder = s.order;
              });
              this.getOptions4Question(s.questions, i);
              this.orderQuestions(this.questionsForm);
            }
          },
          err => console.error(err)
        );
    });

  }

  orderQuestions(questions: QuestionForm[]) {
    let temp: QuestionForm[] = questions;
    if (questions.length > 0) {
      questions.forEach((q, i) => {
        if (q.idtriggerquestion > 0 || q.idtriggerquestion != null) {
          questions.forEach((qq, i) => {
            if (q.idtriggerquestion === qq.id) {
              questions.splice(i);
            }
          })
        }
        console.log("Sin preguntas dependientes: ", questions);
        if (q.idtriggersection > 0 || q.idtriggersection != null) {
          questions.forEach((qq, i) => {
            if (q.idtriggersection === qq.idsection) {
              questions.splice(i);
            }
          })
        }
        console.log("Sin preguntas secciones dependientes: ", questions);
      });
      questions.forEach((q, i) => {
        if (q.idtriggerquestion > 0 || q.idtriggerquestion != null || q.idtriggersection > 0 || q.idtriggersection != null) {
          questions.splice(i)
        }
      });
    }

  }

  getOptions4Question(questions: Question[], i) {
    questions.forEach((q, j) => {
      this.optService.get4question(q.id.toString())
        .subscribe(
          res => {
            let temp: Option[] = res['data'];
            if (temp.length > 0) {
              q.options = temp;
              this.getAxis4Options(q.options, j);
              temp = [];
            }
          },
          err => console.error(err)
        );
    });
  }

  /*  Listar los enlaces de pregunta-pregunta y pregunta-sección */
  getLinks4Question(question: Question) {
    this.linkService.get4Question(question.id.toString())
      .subscribe(
        res => {
          question.linkQuestions = res['data'];
          console.log("Links: ", question.linkQuestions);
        },
        err => console.error(err)
      );
  }

  getAxis4Options(option: Option[], i) {
    option.forEach((op, j) => {
      this.axService.get4Option(op.id.toString())
        .subscribe(
          res => {
            let temp: Axis[] = res['data'];
            if (temp.length > 0) {
              op.axis = temp;
            }
            temp = [];
          },
          err => console.error(err)
        );
    });
  }

  createForm() {
    this.form = this.fb.group({
      id: [null],
      idcreator: [null],
      idstatus: [''],
      name: [''],
      title: [''],
      isActive: [],
      questions: this.fb.array([
        this.fb.group({
          id: [null],
          idquestiontype: [null],
          idsurvey: [null],
          label: [''],
          summary: [''],
          detail: [''],
          order: [''],
          options: this.fb.array([
            this.fb.group({
              id: [null],
              idquestion: [null],
              label: [null],
              isMatrix: [null],
              axis: this.fb.array([
                this.fb.group({
                  id: [null],
                  idoptions: [null],
                  label: [''],
                  type: [],
                  detail: [''],
                  logo: [],
                  isActive: [],
                })
              ])
            })
          ])
        })
      ])
    });

  }

}

